<h2 class="p-gap redesign" style="margin-top: 50px;">Service & Termine</h2>

<div class="column">
    <div class="row">
        <div class="input-field col s12">
            <ul class="service-collapsible highlight collapsible z-depth-0" data-collapsible="accordion"
                style="padding: 0 !important; border: 0 !important;margin-top: -27px;">
                <li>
                    <div class="collapsible-header row space-between center" style="margin-bottom: 0" (click)="openedCollapsiblePart()">

                        <div class="row start center">Abholung
                            <span class="right" *ngIf="driveServiceDateWishIndicator">
                                <i class="material-icons green-text">done</i>
                            </span>
                        </div>

                        <i class="material-icons chevron">keyboard_arrow_down</i>

                    </div>
                    <div class="collapsible-body" style="padding:16px;">
                        <div class="row">
                            <div class="input-field col s6">
                                <input autocomplete="off" id="driveServiceDateTimeWishFrom" type="text"
                                    class="datetimepicker cursor-link driveServiceDateTimeWishFrom"
                                    onkeydown="return false;"
                                    (change)="didChangeBurialFieldWithClass('driveServiceDateTimeWishFrom')">
                                <label for="driveServiceDateTimeWishFrom" class="active">Wunschzeitraum von</label>
                            </div>
                            <div class="input-field col s6">
                                <input autocomplete="off" id="driveServiceDateTimeWishTo" type="text"
                                    class="datetimepicker cursor-link driveServiceDateTimeWishTo"
                                    onkeydown="return false;"
                                    (change)="didChangeBurialFieldWithClass('driveServiceDateTimeWishTo')">
                                <label for="driveServiceDateTimeWishTo" class="active">Wunschzeitraum bis</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <textarea id="driveServiceInfo" class="materialize-textarea driveServiceInfo"
                                    (keyup)="didChangeBurialFieldWithClass('driveServiceInfo')"></textarea>
                                <label for="driveServiceInfo" class="active">Info</label>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="collapsible-header row space-between center" style="margin-bottom: 0" (click)="openedCollapsiblePart()">
                        <div class="row start center">Ein&auml;scherung
                            <span class="right" *ngIf="adoptionTypeIndicator">
                                <i class="material-icons green-text">done</i>
                            </span>
                        </div>

                        <i class="material-icons chevron">keyboard_arrow_down</i>
                    </div>
                    <div class="collapsible-body" style="padding:16px;">
                        <div class="row">
                            <div class="input-field col s12">
                                <select id="adoptionType" class="adoptionType browser-default"
                                    (change)="didChangeBurialFieldWithClass('adoptionType')"
                                    style="margin-top:-10px;margin-bottom:10px;">
                                    <option value="0" selected>Ein&auml;scherungsart w&auml;hlen</option>
                                    <option value="2">Ein&auml;scherung ohne Angeh&ouml;rigen</option>
                                    <option value="13">Aufbahrung (Sarg offen)</option>
                                    <option value="14">Aufbahrung (Sarg geschlossen)</option>
                                    <option value="15">Trauerfeier mit Urne</option>
                                    <option value="5">Ein&auml;scherung mit Angeh&ouml;rigen ohne Halle</option>
                                    <option value="1">Ein&auml;scherung mit Angeh&ouml;rigen mit Halle</option>
                                    <option value="3">Sargverabschiedung in der Trauerhalle</option>
                                    <option value="4">Sargverabschiedung in der Trauerhalle mit anschlie&szlig;ender Direktein&auml;scherung</option>
                                    <option value="7">Bestatter 1 Stunde vor Ein&auml;scherung anrufen</option>
                                </select>
                            </div>
                        </div>
                        <span *ngIf="adoptionTypeIndicator">
                            <div class="row">
                                <div class="input-field col s12"> 
                                    <input autocomplete="off" id="adoptionDateTimeWish" type="text"
                                        class="datetimepicker cursor-link adoptionDateTimeWish"
                                        (input)="didChangeBurialFieldWithClass('adoptionDateTimeWish')"
                                        (selectedChange)="didChangeBurialFieldWithClass('adoptionDateTimeWish')"
                                        (keyup)="didChangeBurialFieldWithClass('adoptionDateTimeWish')"
                                        (change)="didChangeBurialFieldWithClass('adoptionDateTimeWish')"  >
                                    <label for="adoptionDateTimeWish" class="active">Wunschtermin (Datum /
                                        Uhrzeit)</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="input-field col s12">
                                    <textarea id="adoptionTypeInfo" class="materialize-textarea adoptionTypeInfo"
                                        (keyup)="didChangeBurialFieldWithClass('adoptionTypeInfo')"></textarea>
                                    <label for="adoptionTypeInfo" class="active">Info</label>
                                </div>
                            </div>
                        </span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>